import React from "react";
import {
  Grid,
  Typography,
  Theme,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  makeStyles,
} from "@material-ui/core";
import moment from "moment";
import {
  useFirestore,
  useFirestoreDocData,
  useFirestoreCollectionData,
} from "reactfire";
import { useParams } from "react-router";
import AddYeastLogDialog from "../../components/Dialogs/AddYeastLogDialog/AddYeastLogDialog";

const useStyles = makeStyles((theme: Theme) => ({
  gridItem: {
    padding: theme.spacing(2),
  },
}));

const BrewDetailPage = () => {
  const classes = useStyles();
  const { brewId } = useParams();
  const brewRef = useFirestore().collection("brews").doc(brewId);
  const brew: any = useFirestoreDocData(brewRef);
  console.log(brew);

  const yeastLogsRef = useFirestore()
    .collection("yeast-logs")
    .where("brew", "==", brewId);
  const yeastLogs = useFirestoreCollectionData(yeastLogsRef);

  return (
    <Grid container>
      <Grid item xs className={classes.gridItem}>
        <Typography variant="subtitle1">{brew.name}</Typography>
        <Typography variant="body1" gutterBottom>
          <i>{brew.date}</i>
        </Typography>
        <hr />
        <Typography variant="subtitle1">Vergisting</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Datum</TableCell>
              <TableCell>SG</TableCell>
              <TableCell>BRIX</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={2}>
                <AddYeastLogDialog />
              </TableCell>
              <TableCell colSpan={1} align="right">
                <Button>Voltooi vergisting</Button>
              </TableCell>
            </TableRow>
            {yeastLogs.map((log: any) => (
              <TableRow>
                <TableCell>
                  {moment(log.date.seconds * 1000).format("YYYY-MM-DD")}
                </TableCell>
                <TableCell>{log.hydroSG}</TableCell>
                <TableCell>{log.refractoBrix}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
};

export default BrewDetailPage;
